'use strict';
const qs = require('querystring');
const url = require('url');
const client = {
  https: require('https'),
  http: require('http'),
};

const REDIRECT_CODES = [301, 302, 303, 307];
class SimpleError extends Error {
  constructor() {
    super('Error happened due to simple constraint not being 2xx status code.');
    this.name = 'FR_Simple';
  }
}
class RequestError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_' + e.name;
  }
}

class RequestTimeoutError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_Timeout';
  }
}

class Fasquest {
  constructor() {
    this.agent = {
      http: new client.http.Agent({
        keepAlive: true,
      }),
      https: new client.https.Agent({
        keepAlive: true,
      }),
    };
  }
  request(options, cb = null) {
    if (!cb) {
      return this.requestPromise(options);
    } else {
      this._request(options, (req, res, err) => {
        cb({
          req,
          res,
          err,
        });
      });
    }
  }
  requestPromise(options) {
    return new Promise((resolve, reject) => {
      this._request(options, (req, res, err) => {
        if (err) {
          reject({
            req,
            res,
            err,
          });
        } else {
          resolve(options.resolveWithFullResponse ? res : res.body);
        }
      });
    });
  }
  _request(ops, cb, count = 0) {
    var options = this._setOptions(ops);

    var req = client[options.proto].request(options, (res) => {
      res.body = '';

      res.on('data', (chunk) => {
        res.body += chunk;
      });

      res.on('end', () => {
        if (options.timeout) {
          clearTimeout(t);
        }
        // remove as causes circular references

        if (
          REDIRECT_CODES.indexOf(res.statusCode) !== -1 &&
          count < options.redirect_max
        ) {
          options.uri = url.resolve(options.uri, res.headers.location);
          return this._request(this._setOptions(options), cb, ++count);
        } else {
          if (
            res.headers['content-type'] &&
            res.headers['content-type'].indexOf('json') > -1
          ) {
            try {
              res.body = JSON.parse(res.body);
            } catch (e) {
              // do nothing
            }
          }
          if (options.simple) {
            if (res.statusCode > 299 || res.statusCode < 200) {
              return cb(req, res, new SimpleError());
            }
          }
          return cb(req, res, null);
        }
      });
    });

    if (options.timeout) {
      var t = setTimeout(() => {
        req.destroy();
      }, options.timeout || 60000);
    }

    req.on('error', (e) => {
      var err =
        e.message.indexOf('socket hang up') > -1
          ? new RequestTimeoutError(e)
          : new RequestError(e);

      return cb(req, null, err);
    });

    if (options.body) {
      req.write(options.body);
    }
    req.end();
  }
  _setOptions(opts) {
    var options = {};

    options.simple = opts.simple !== false;
    options.method = opts.method || 'GET';
    options.uri = opts.uri;
    options.timeout = opts.timeout;

    if (opts.qs) {
      var escQS = qs.stringify(opts.qs);

      if (escQS.length > 0) {
        options.uri += (options.uri.indexOf('?') > -1 ? '&' : '?') + escQS;
      }
    }
    options = this._uri_to_options(options.uri, options);
    options.agent = opts.agent || this.agent[opts.proto];
    options.headers = {};
    if (opts.headers) {
      var h = Object.keys(opts.headers);

      for (var i = 0; i < h.length; i++) {
        options.headers[h[i]] = opts.headers[h[i]];
      }
    }
    if (opts.json) {
      options.headers['Content-Type'] = 'application/json';
      if (opts.body) {
        options.body = JSON.stringify(opts.body);
      }
    } else if (opts.form) {
      options.body = qs.stringify(opts.form);

      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      options.headers['Content-Length'] = Buffer.byteLength(options.body);
    } else if (opts.body) {
      options.headers['Content-Length'] = Buffer.byteLength(opts.body);
      if (!options.headers['Content-Type']) {
        options.headers['Content-Type'] = 'text/plain';
      }
      options.body = opts.body;
    }
    if (opts.authorization) {
      if (opts.authorization.basic) {
        options.headers['Authorization'] =
          'Basic ' +
          Buffer.from(
            opts.authorization.basic.client +
              ':' +
              opts.authorization.basic.secret,
            'ascii'
          ).toString('base64');
      } else if (opts.authorization.bearer) {
        options.headers['Authorization'] =
          'Bearer ' + opts.authorization.bearer;
      }
    }
    if (!opts.redirect_max && opts.redirect_max !== 0) {
      options.redirect_max = 5;
    }

    return options;
  }
  _uri_to_options(uri, options) {
    var convertedUri = {
      proto: '',
      path: '',
      port: 80,
      host: '',
    };
    var splitURI = uri.split('://');

    convertedUri.proto = splitURI[0];
    var possiblePort = splitURI[1].indexOf(':');

    if (possiblePort > -1 && !isNaN(splitURI[1][possiblePort + 1])) {
      const pindex = splitURI[1].indexOf('/');

      if (pindex > -1) {
        convertedUri.path = splitURI[1].slice(pindex);
        convertedUri.port = splitURI[1].slice(possiblePort + 1, pindex);
      } else {
        convertedUri.port = splitURI[1].slice(possiblePort + 1);
      }
      convertedUri.host = splitURI[1].slice(0, possiblePort);
    } else {
      convertedUri.port = convertedUri.proto == 'https' ? 443 : 80;
    }
    const hostIndex = splitURI[1].indexOf('/');

    if (hostIndex > -1) {
      convertedUri.path = convertedUri.path || splitURI[1].slice(hostIndex);
      convertedUri.host = convertedUri.host || splitURI[1].slice(0, hostIndex);
    } else {
      convertedUri.path = convertedUri.path || '/';
      convertedUri.host = convertedUri.host || splitURI[1];
    }
    options.proto = convertedUri.proto;
    options.path = convertedUri.path;
    options.port = convertedUri.port;
    options.host = convertedUri.host;
    return options;
  }
}
module.exports = new Fasquest();

/**
 * SDK - importing the SDK for use
 * @param {string} host the hostname to the service (example: http://127.0.0.1)
 * @param {object} opts options that will be appened to every request. [Fasquest Lib Options](https://github.com/Phara0h/Fasquest) (example: {headers: {'API-KEY':'34098hodf'}})
 * @example
 * init
 * ```js
 * const { DigitalProducts } = require('./sdk.js')('http://127.0.0.1');
 * ```
 */
function SDK(host, opts) {
  var hostUrl = '';
  var defaultOpts = null;

  if (host) {
    hostUrl = host;
  }
  if (opts) {
    defaultOpts = opts;
  }
  const fasq = new Fasquest();

  /**
   *
   */
  class DigitalProducts {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        metrics: 'digital-products/metrics',
        healthcheck: 'digital-products/health',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * metrics -
     *
     * Path: digital-products/metrics
     */
    static async metrics(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `digital-products/metrics`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * healthCheck - Placeholder new request
     *
     * Path: digital-products/health
     */
    static async healthCheck(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `digital-products/health`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Reports() {
      return Reports;
    }

    static get SexOffender() {
      return SexOffender;
    }
  }
  /**
   *
   */
  class Reports {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        meta: 'digital-products/v1/reports/account/:accountId/meta/type/:type',
        report:
          'digital-products/v1/reports/account/:accountId/type/:type/report/:reportCode',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * meta -
     *
     * Path: digital-products/v1/reports/account/:accountId/meta/type/:type
     * @param {any} accountId  (example: 1e0f5c28-57f2-4340-892d-6e71b35cf4a0)
     * @param {any} type `all,people,phone,adress` are the options (example: address)
     */
    static async meta(accountId, type, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/meta/type/${type}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * report -
     *
     * Path: digital-products/v1/reports/account/:accountId/type/:type/report/:reportCode
     * @param {any} accountId  (example: 1e0f5c28-57f2-4340-892d-6e71b35cf4a0)
     * @param {any} type `all,people,phone,address` are the options (example: address)
     * @param {any} reportCode  (example: 531cbb660e51556d8e4be8bb1e801b6f)
     * @param {any} updateMeta Optional. Defaults to true. Turns off reports 'seen' metadata update on report pull. (example: false)
     * @param {any} sex_offenders Optional. Defaults to false. (example: true)
     */
    static async report(
      accountId,
      type,
      reportCode,
      updateMeta,
      sex_offenders,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/type/${type}/report/${reportCode}`,
        qs: { updateMeta, sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Email() {
      return ReportsEmail;
    }

    static get Pdf() {
      return ReportsPdf;
    }

    static get Generate() {
      return ReportsGenerate;
    }
  }
  /**
   *
   */
  class ReportsEmail {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        pdf:
          'digital-products/v1/reports/pdf/email/account/:accountId/type/:type/report/:reportCode',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * pdf -
     *
     * Path: digital-products/v1/reports/pdf/email/account/:accountId/type/:type/report/:reportCode
     * @param {any} accountId Account ID for the inventory generating the report, and to email report to. (example: 15455551-2891-4a03-a124-7ffafa93b94b)
     * @param {any} type Type of the report to generate (people or phone). (example: phone)
     * @param {any} reportCode reportCode of the report to generate and email. (example: 1d4955e26bdff51ff4944bf2f9d1c452)
     * @param {any} filename Optional. Defaults to report firstname and lastname. Optional to add .pdf, will get automatically affixed. (example: test_filename)
     */
    static async pdf(accountId, type, reportCode, filename, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/pdf/email/account/${accountId}/type/${type}/report/${reportCode}`,
        qs: { filename },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class ReportsPdf {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        base64:
          'digital-products/v1/reports/pdf/base64/account/:accountId/type/:type/report/:reportCode',
        binary:
          'digital-products/v1/reports/pdf/binary/account/:accountId/type/:type/report/:reportCode',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * base64 -
     *
     * Path: digital-products/v1/reports/pdf/base64/account/:accountId/type/:type/report/:reportCode
     * @param {any} accountId Account ID for the inventory generating the report. (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     * @param {any} type Type of the report to generate (people or phone). (example: people)
     * @param {any} reportCode reportCode of the report to generate. (example: 3eee590ea8f40c4932e339590d44b2f1)
     * @param {any} sex_offenders Default: False (example: true)
     */
    static async base64(accountId, type, reportCode, sex_offenders, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/pdf/base64/account/${accountId}/type/${type}/report/${reportCode}`,
        qs: { sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * binary -
     *
     * Path: digital-products/v1/reports/pdf/binary/account/:accountId/type/:type/report/:reportCode
     * @param {any} accountId Account ID for the inventory generating the report. (example: 4bc3afc9-3e25-41c4-9e8d-359fa97f3050)
     * @param {any} type Type of the report to generate (people or phone). (example: people)
     * @param {any} reportCode reportCode of the report to generate. (example: 04772d4f-1ab3-4ce1-8c36-63342b2dd9b6)
     * @param {any} sex_offenders Default: False (example: true)
     */
    static async binary(accountId, type, reportCode, sex_offenders, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/pdf/binary/account/${accountId}/type/${type}/report/${reportCode}`,
        qs: { sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class ReportsGenerate {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        pdfbase64:
          'digital-products/v1/reports/account/:accountId/person/:personId/generate/pdf/base64',
        pdf:
          'digital-products/v1/reports/account/:accountId/person/:personId/generate/pdf',
        json:
          'digital-products/v1/reports/account/:accountId/person/:personId/generate/json',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * pdfbase64 -
     *
     * Path: digital-products/v1/reports/account/:accountId/person/:personId/generate/pdf/base64
     * @param {any} accountId  (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     * @param {any} personId  (example: 6a68d5b3-f5a1-4f3d-ebe1-a7dabdf2235d)
     */
    static async pdfbase64(accountId, personId, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/person/${personId}/generate/pdf/base64`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * pdf -
     *
     * Path: digital-products/v1/reports/account/:accountId/person/:personId/generate/pdf
     * @param {any} accountId  (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     * @param {any} personId  (example: 6a68d5b3-f5a1-4f3d-ebe1-a7dabdf2235d)
     */
    static async pdf(accountId, personId, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/person/${personId}/generate/pdf`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * json -
     *
     * Path: digital-products/v1/reports/account/:accountId/person/:personId/generate/json
     * @param {any} accountId Account ID. (example: 9f89b6d5-6e21-4725-8702-f80afd3d810a)
     * @param {any} personId Customer CID for the property they are in (example: FGDF-WG3T)
     * @param {any} sex_offenders Optional. Boolean, if true will attach relavent sex_offenders array for the report. (example: true)
     */
    static async json(accountId, personId, sex_offenders, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/person/${personId}/generate/json`,
        qs: { sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Address() {
      return ReportsGenerateAddress;
    }

    static get Phones() {
      return ReportsGeneratePhones;
    }
  }
  /**
   *
   */
  class ReportsGenerateAddress {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        pdfbase64:
          'digital-products/v1/reports/account/:accountId/zip/:zip/state/:state/city/:city/street/:street/generate/pdf/base64',
        jsonbyid:
          'digital-products/v1/reports/address/account/:accountId/id/:id/generate/json',
        json:
          'digital-products/v1/reports/account/:accountId/zip/:zip/state/:state/city/:city/street/:street/generate/json',
        pdf:
          'digital-products/v1/reports/account/:accountId/zip/:zip/state/:state/city/:city/street/:street/generate/pdf',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * pdfbase64 -
     *
     * Path: digital-products/v1/reports/account/:accountId/zip/:zip/state/:state/city/:city/street/:street/generate/pdf/base64
     * @param {string} accountId  (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     * @param {string} zip  (example: 22121)
     * @param {string} state  (example: VA)
     * @param {string} city  (example: MT%20VERNON)
     * @param {string} street  (example: 3200%20Mount%20Vernon%20Memorial%20Highway)
     */
    static async pdfbase64(accountId, zip, state, city, street, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/zip/${zip}/state/${state}/city/${city}/street/${street}/generate/pdf/base64`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * jsonById -
     *
     * Path: digital-products/v1/reports/address/account/:accountId/id/:id/generate/json
     * @param {string} accountId Account ID. (example: 7271f283-86bc-49f4-beb7-5dd81fa95921)
     * @param {any} id  (example: FJW8-7F1S)
     * @param {any} sex_offenders Optional. Boolean, if true will attach relavent sex_offenders array for the report. (example: true)
     */
    static async jsonById(accountId, id, sex_offenders, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/address/account/${accountId}/id/${id}/generate/json`,
        qs: { sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * json -
     *
     * Path: digital-products/v1/reports/account/:accountId/zip/:zip/state/:state/city/:city/street/:street/generate/json
     * @param {string} accountId Account ID. (example: 7271f283-86bc-49f4-beb7-5dd81fa95921)
     * @param {string} zip  (example: 22121)
     * @param {string} state  (example: VA)
     * @param {string} city  (example: MT%20VERNON)
     * @param {string} street  (example: 3200%20Mount%20Vernon%20Memorial%20Highway)
     * @param {any} sex_offenders Optional. Boolean, if true will attach relavent sex_offenders array for the report.
     */
    static async json(
      accountId,
      zip,
      state,
      city,
      street,
      sex_offenders,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/zip/${zip}/state/${state}/city/${city}/street/${street}/generate/json`,
        qs: { sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * pdf -
     *
     * Path: digital-products/v1/reports/account/:accountId/zip/:zip/state/:state/city/:city/street/:street/generate/pdf
     * @param {string} accountId  (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     * @param {string} zip  (example: 22121)
     * @param {string} state  (example: VA)
     * @param {string} city  (example: MT%20VERNON)
     * @param {string} street  (example: 3200%20Mount%20Vernon%20Memorial%20Highway)
     */
    static async pdf(accountId, zip, state, city, street, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/zip/${zip}/state/${state}/city/${city}/street/${street}/generate/pdf`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class ReportsGeneratePhones {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        pdfbase64:
          'digital-products/v1/reports/account/:accountId/phone/:phone/generate/pdf/base64',
        pdf:
          'digital-products/v1/reports/account/:accountId/phone/:phone/generate/pdf',
        jsonbyid:
          'digital-products/v1/reports/phones/account/:accountId/id/:id/generate/json',
        json:
          'digital-products/v1/reports/account/:accountId/phone/:phone/generate/json',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * pdfbase64 -
     *
     * Path: digital-products/v1/reports/account/:accountId/phone/:phone/generate/pdf/base64
     * @param {any} accountId  (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     * @param {any} phone
     */
    static async pdfbase64(accountId, phone, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/phone/${phone}/generate/pdf/base64`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * pdf -
     *
     * Path: digital-products/v1/reports/account/:accountId/phone/:phone/generate/pdf
     * @param {any} accountId  (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     * @param {any} phone
     */
    static async pdf(accountId, phone, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/phone/${phone}/generate/pdf`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * jsonById -
     *
     * Path: digital-products/v1/reports/phones/account/:accountId/id/:id/generate/json
     * @param {any} accountId Account ID. (example: 7271f283-86bc-49f4-beb7-5dd81fa95921)
     * @param {any} id  (example: 5W2K-X73L)
     * @param {any} sex_offenders Optional. Boolean, if true will attach relavent sex_offenders array for the report. (example: true)
     */
    static async jsonById(accountId, id, sex_offenders, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/phones/account/${accountId}/id/${id}/generate/json`,
        qs: { sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * json -
     *
     * Path: digital-products/v1/reports/account/:accountId/phone/:phone/generate/json
     * @param {any} accountId Account ID. (example: 7271f283-86bc-49f4-beb7-5dd81fa95921)
     * @param {any} phone
     * @param {any} sex_offenders Optional. Boolean, if true will attach relavent sex_offenders array for the report. (example: true)
     */
    static async json(accountId, phone, sex_offenders, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/reports/account/${accountId}/phone/${phone}/generate/json`,
        qs: { sex_offenders },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class SexOffender {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        bystreet:
          'digital-products/v1/sexoffender/account/:account/zip/:zip/street/:street',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byStreet -
     *
     * Path: digital-products/v1/sexoffender/account/:account/zip/:zip/street/:street
     * @param {any} account Required - Account ID pulling the Offenders (example: 3dd5a7d5-891a-4b3f-9c51-93c8225f5fe9)
     * @param {any} zip Required - Zip for the search area (example: 32805)
     * @param {any} street Required - Street for the search area (example: 513 19th St)
     * @param {any} mile_radius Optional - Radius to search around location (default 1) (example: 5)
     * @param {any} page Optional - Page to query for (default 1) (example: 2)
     * @param {any} limit Optional - Limit per page (default 25) (example: 50)
     */
    static async byStreet(
      account,
      zip,
      street,
      mile_radius,
      page,
      limit,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `digital-products/v1/sexoffender/account/${account}/zip/${zip}/street/${street}`,
        qs: { mile_radius, page, limit },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }

  return {
    DigitalProducts,
    Reports,
    ReportsEmail,
    ReportsPdf,
    ReportsGenerate,
    ReportsGenerateAddress,
    ReportsGeneratePhones,
    SexOffender,
  };
}
module.exports = SDK;

